// extracted by mini-css-extract-plugin
export default {"header_address_list":"HeaderAddress_header_address_list__fEim4"};